import React, { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";
import {
  FaCalendarAlt,
  FaClock,
  FaUsers,
  FaMapMarkerAlt,
  FaPlus,
  FaSearch,
  FaEye,
  FaEdit,
  FaTrash,
  FaTimes,
} from "react-icons/fa";
import Swal from "sweetalert2";
import { useSidebar } from '../context/SidebarContext';
import { useNavigate } from 'react-router-dom'; 
import styles from '../styles/ActivitesPage';
import OrganisationSelector from '../components/OrganisationSelector';
import { useAuth } from '../context/AuthContext';




const ActivitesPage = () => {
  const [activites, setActivites] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedActivite, setSelectedActivite] = useState(null);
  const { sidebarVisible } = useSidebar();
  const [employes, setEmployes] = useState([]);
  
  // États pour la gestion des organisations
  const [selectedOrganisation, setSelectedOrganisation] = useState('');
  const [currentOrganisation, setCurrentOrganisation] = useState(null);

  const [formData, setFormData] = useState({
    nom: "",
    description: "",
    date: "",
    heure_debut: "",
    heure_fin: "",
    lieu: "",
    est_active: true,
    employes: []
  });

  const api = useAxios();
  const navigate = useNavigate();
  const { user } = useAuth();
  useEffect(() => {
    if (selectedOrganisation) {
      fetchActivites();
      fetchEmployes();
    }
  }, [selectedOrganisation]);

  // Gestionnaire de changement d'organisation
  const handleOrganisationChange = (orgId, org) => {
    setSelectedOrganisation(orgId);
    setCurrentOrganisation(org);
    
    setActivites([]);
    setEmployes([]);
  };

  const fetchActivites = async () => {
    try {
      const response = await api.get(`/pointage/activites/?organisation=${selectedOrganisation}`);
      setActivites(response.data);
    } catch (error) {
      console.error("Erreur API:", error);
      setError("Impossible de récupérer les activités.");
    }
  };

  const fetchEmployes = async () => {
    try {
      const response = await api.get(`/employes/?organisation=${selectedOrganisation}`);
      setEmployes(response.data);
    } catch (error) {
      console.error("Erreur API:", error);
    }
  };

  const filteredActivites = activites.filter((act) => {
    if (!act || !act.nom) return false;
    return (
        act.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (act.description && act.description.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleEmployeSelect = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, option => parseInt(option.value));
    setFormData({
      ...formData,
      employes: selectedOptions
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      
      const dataToSend = {
        ...formData,
        organisation: selectedOrganisation
      };
      
      const response = await api.post("/pointage/activites/create/", dataToSend);
      
      if (response.data) {
        await fetchActivites();
        setShowModal(false);
        // Réinitialiser le formulaire
        setFormData({
          nom: "",
          description: "",
          date: "",
          heure_debut: "",
          heure_fin: "",
          lieu: "",
          est_active: true,
          employes: []
        });
        Swal.fire({
          title: "Activité créée avec succès",
          icon: "success",
          toast: true,
          timer: 3000,
          position: "top-right",
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Erreur lors de la création:", error);
      Swal.fire({
        title: "Erreur lors de la création",
        text: error.response?.data?.message || "Une erreur est survenue",
        icon: "error",
      });
    }
  };

  const handleView = (activite) => {
    setSelectedActivite(activite);
    setShowViewModal(true);
  };

  const handleEdit = (activite) => {
    setFormData({
      nom: activite.nom,
      description: activite.description,
      date: activite.date,
      heure_debut: activite.heure_debut,
      heure_fin: activite.heure_fin,
      lieu: activite.lieu,
      est_active: activite.est_active,
      employes: activite.employes.map(id => String(id)) 
    });
    setSelectedActivite(activite);
    setShowEditModal(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    
    try {
      
      const dataToSend = {
        ...formData,
        organisation: selectedOrganisation
      };
      
      const response = await api.put(`/pointage/activites/${selectedActivite.id}/update/`, dataToSend);
      
      if (response.data) {
        setActivites(activites.map(act => 
          act.id === selectedActivite.id ? response.data : act
        ));
        setShowEditModal(false);
        Swal.fire({
          title: "Activité modifiée avec succès",
          icon: "success",
          toast: true,
          timer: 3000,
          position: "top-right",
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Erreur lors de la modification:", error);
      Swal.fire({
        title: "Erreur lors de la modification",
        text: error.response?.data?.message || "Une erreur est survenue",
        icon: "error",
      });
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Supprimer cette activité ?",
      text: "Cette action est irréversible.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Oui, supprimer",
    });

    if (confirm.isConfirmed) {
      try {
        await api.delete(`/pointage/activites/${id}/delete/`);
        setActivites(activites.filter(act => act.id !== id));
        Swal.fire("Supprimé !", "L'activité a été supprimée.", "success");
      } catch (error) {
        console.error("Erreur suppression:", error);
        Swal.fire("Erreur", "Impossible de supprimer l'activité.", "error");
      }
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    return timeString.slice(0, 5); 
  };

  return (
    <div style={{...styles.container, marginLeft: sidebarVisible ? 250 : 0}}>
      <h1 style={styles.header}>
       ACTIVITÉS EXCEPTIONNELLES
      </h1>

      {/* Header avec sélecteur d'organisation */}
      <div style={styles.organisationHeader}>
        <OrganisationSelector 
          onOrganisationChange={handleOrganisationChange}
          selectedOrganisation={selectedOrganisation}
        />

        {currentOrganisation && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: '#666', fontSize: '14px' }}>
              Activités pour cette organisation
            </span>
          </div>
        )}
      </div>

      {currentOrganisation ? (
        <>
          <div style={styles.filterBar}>
            {(user?.is_super_admin || user?.permissions?.includes("CREATE_ACTIVITY")) && (
            <button
              onClick={() => setShowModal(true)}
              style={styles.addButton}
            >
              <FaPlus style={{ marginRight: "8px" }} /> Ajouter
            </button>
            )}
            <div style={styles.searchContainer}>
              <FaSearch style={{ marginRight: "8px", color: "#1B019B" }} />
              <input
                type="text"
                placeholder="Rechercher une activité..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.searchInput}
              />
            </div>

            <span style={styles.countBadge}>
              {activites.length} activités
            </span>
          </div>

          {error ? (
            <p style={{ color: "red" }}>{error}</p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={styles.table}>
                <thead style={styles.tableHeader}>
                  <tr>
                    <th>Nom</th>
                    <th><FaCalendarAlt /> Date</th>
                    <th><FaClock /> Heures</th>
                    <th><FaUsers /> Participants</th>
                    <th><FaMapMarkerAlt /> Lieu</th>
                    <th>Statut</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredActivites.length > 0 ? (
                    filteredActivites.map((act) => (
                      <tr key={act.id}>
                        <td>{act.nom}</td>
                        <td>{formatDate(act.date)}</td>
                        <td>
                          {formatTime(act.heure_debut)} - {formatTime(act.heure_fin)}
                        </td>
                        <td>{act.employes.length} participant(s)</td>
                        <td>{act.lieu || "Non spécifié"}</td>
                        <td>
                          <span style={styles.statusBadge(act.est_active)}>
                            {act.est_active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                          <button
                            style={{...styles.actionButton, ...styles.viewButton}}
                            title="Voir"
                            onClick={() => handleView(act)}
                          >
                            <FaEye />
                          </button>
                          <button
                            style={{...styles.actionButton, ...styles.editButton}}
                            title="Modifier"
                            onClick={() => handleEdit(act)}
                          >
                            <FaEdit />
                          </button>
                          <button
                            style={{...styles.actionButton, ...styles.deleteButton}}
                            title="Supprimer"
                            onClick={() => handleDelete(act.id)}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center", padding: "15px", color: "#777" }}>
                        Aucune activité trouvée.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
                  
            <div className="mt-4 d-flex justify-content-end gap-2">
              {(user?.is_super_admin || user?.permissions?.includes("VIEW_EXCEPTIONAL_PRESENCES")) && (
              <button
                style={{...styles.navigationButton, ...styles.primaryNavButton}}
                onClick={() => navigate('/presence-exeptionnelle')}
              >
                <FaCalendarAlt /> Présences pour les activités
              </button>
              )}
              {/* {(user?.is_super_admin || user?.permissions?.includes("VIEW_OVERTIME_BY_ACTIVITY")) && (
              <button
                style={{...styles.navigationButton, ...styles.secondaryNavButton}}
                onClick={() => navigate('/heure-sup')}
              >
                <FaClock /> Heure supplémentaires
              </button>
              )} */}
            </div>

            </div>
          )}

          {/* Modal pour création */}
          {showModal && (
            <div style={styles.modalOverlay}>
              <div style={styles.modalContent}>
                <button onClick={() => setShowModal(false)} style={styles.closeButton}>
                  <FaTimes />
                </button>
                <h2 style={styles.modalTitle}>
                  Créer une Activité Exceptionnelle
                </h2>
                <form onSubmit={handleSubmit}>
                  <div style={styles.formGroup}>
                    <label htmlFor="nom">Nom de l'activité *</label>
                    <input 
                      type="text" 
                      name="nom" 
                      value={formData.nom} 
                      onChange={handleChange} 
                      required 
                      style={styles.formInput}
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label htmlFor="description">Description</label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      rows="3"
                      style={styles.formInput}
                    />
                  </div>

                  <div style={styles.formRow}>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="date">Date *</label>
                      <input 
                        type="date" 
                        name="date" 
                        value={formData.date} 
                        onChange={handleChange} 
                        required 
                        style={styles.formInput}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="lieu">Lieu</label>
                      <input 
                        type="text" 
                        name="lieu" 
                        value={formData.lieu} 
                        onChange={handleChange} 
                        style={styles.formInput}
                      />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="heure_debut">Heure de début</label>
                      <input 
                        type="time" 
                        name="heure_debut" 
                        value={formData.heure_debut} 
                        onChange={handleChange} 
                        style={styles.formInput}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="heure_fin">Heure de fin</label>
                      <input 
                        type="time" 
                        name="heure_fin" 
                        value={formData.heure_fin} 
                        onChange={handleChange} 
                        style={styles.formInput}
                      />
                    </div>
                  </div>

                  <div style={styles.formGroup}>
                    <label htmlFor="employes">Participants</label>
                    <select
                      name="employes"
                      multiple
                      value={formData.employes}
                      onChange={handleEmployeSelect}
                      style={styles.formSelect}
                    >
                      {employes.map(emp => (
                        <option key={emp.id} value={emp.id}>
                          {emp.first_name} {emp.last_name} ({emp.poste})
                        </option>
                      ))}
                    </select>
                    <small style={{ color: "#666" }}>Maintenez Ctrl (Windows) ou Cmd (Mac) pour sélectionner plusieurs</small>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                    <input
                      type="checkbox"
                      id="est_active"
                      name="est_active"
                      checked={formData.est_active}
                      onChange={handleChange}
                      style={{ marginRight: "10px" }}
                    />
                    <label htmlFor="est_active">Activité active</label>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <button type="submit" style={styles.submitButton}>
                      Créer l'activité
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Modal pour visualisation */}
          {showViewModal && selectedActivite && (
            <div style={styles.modalOverlay}>
              <div style={styles.modalContent}>
                <button onClick={() => setShowViewModal(false)} style={styles.closeButton}>
                  <FaTimes />
                </button>
                <h2 style={styles.modalTitle}>
                  {selectedActivite.nom}
                </h2>

                <div style={{ marginBottom: "20px" }}>
                  <h3 style={{ color: "#1e3c72", borderBottom: "1px solid #eee", paddingBottom: "5px" }}>
                    Détails
                  </h3>
                  <p><strong>Date:</strong> {formatDate(selectedActivite.date)}</p>
                  {selectedActivite.heure_debut && (
                    <p>
                      <strong>Heures:</strong> {formatTime(selectedActivite.heure_debut)} - {formatTime(selectedActivite.heure_fin)}
                    </p>
                  )}
                  {selectedActivite.lieu && (
                    <p><strong>Lieu:</strong> {selectedActivite.lieu}</p>
                  )}
                  <p>
                    <strong>Statut:</strong> 
                    <span style={styles.statusBadge(selectedActivite.est_active)}>
                      {selectedActivite.est_active ? "Active" : "Inactive"}
                    </span>
                  </p>
                </div>

                {selectedActivite.description && (
                  <div style={{ marginBottom: "20px" }}>
                    <h3 style={{ color: "#1e3c72", borderBottom: "1px solid #eee", paddingBottom: "5px" }}>
                      Description
                    </h3>
                    <p style={{ whiteSpace: "pre-line" }}>{selectedActivite.description}</p>
                  </div>
                )}

                <div style={{ marginBottom: "20px" }}>
                  <h3 style={{ color: "#1e3c72", borderBottom: "1px solid #eee", paddingBottom: "5px" }}>
                    Participants ({selectedActivite.employes?.length || 0})
                  </h3>
                  
                  {selectedActivite.employes && selectedActivite.employes.length > 0 ? (
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                      {selectedActivite.employes.map((empId, index) => {
                        const emp = employes.find(e => e.id === empId);
                        return emp ? (
                          <li key={`emp-${empId}-${index}`} style={{ padding: "5px 0", borderBottom: "1px solid #f0f0f0" }}>
                            {emp.first_name} {emp.last_name} - {emp.poste} ({emp.matricule})
                          </li>
                        ) : null;
                      })}
                    </ul>
                  ) : (
                    <p>Aucun participant</p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Modal pour modification */}
          {showEditModal && selectedActivite && (
            <div style={styles.modalOverlay}>
              <div style={styles.modalContent}>
                <button onClick={() => setShowEditModal(false)} style={styles.closeButton}>
                  <FaTimes />
                </button>
                <h2 style={styles.modalTitle}>
                  Modifier l'Activité
                </h2>
                <form onSubmit={handleEditSubmit}>
                  <div style={styles.formGroup}>
                    <label htmlFor="nom">Nom de l'activité *</label>
                    <input 
                      type="text" 
                      name="nom" 
                      value={formData.nom} 
                      onChange={handleChange} 
                      required 
                      style={styles.formInput}
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label htmlFor="description">Description</label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      rows="3"
                      style={styles.formInput}
                    />
                  </div>

                  <div style={styles.formRow}>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="date">Date *</label>
                      <input 
                        type="date" 
                        name="date" 
                        value={formData.date} 
                        onChange={handleChange} 
                        required 
                        style={styles.formInput}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="lieu">Lieu</label>
                      <input 
                        type="text" 
                        name="lieu" 
                        value={formData.lieu} 
                        onChange={handleChange} 
                        style={styles.formInput}
                      />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="heure_debut">Heure de début</label>
                      <input 
                        type="time" 
                        name="heure_debut" 
                        value={formData.heure_debut} 
                        onChange={handleChange} 
                        style={styles.formInput}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label htmlFor="heure_fin">Heure de fin</label>
                      <input 
                        type="time" 
                        name="heure_fin" 
                        value={formData.heure_fin} 
                        onChange={handleChange} 
                        style={styles.formInput}
                      />
                    </div>
                  </div>

                  <div style={styles.formGroup}>
                    <label htmlFor="employes">Participants</label>
                    <select
                      name="employes"
                      multiple
                      value={formData.employes}
                      onChange={handleEmployeSelect}
                      style={styles.formSelect}
                    >
                      {employes.map(emp => (
                        <option key={emp.id} value={String(emp.id)}>
                          {emp.first_name} {emp.last_name} ({emp.poste})
                        </option>
                      ))}
                    </select>
                    <small style={{ color: "#666" }}>Maintenez Ctrl (Windows) ou Cmd (Mac) pour sélectionner plusieurs</small>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                    <input
                      type="checkbox"
                      id="est_active"
                      name="est_active"
                      checked={formData.est_active}
                      onChange={handleChange}
                      style={{ marginRight: "10px" }}
                    />
                    <label htmlFor="est_active">Activité active</label>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <button type="submit" style={styles.submitButton}>
                      Enregistrer les modifications
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-5">
          <p className="text-muted">Sélectionnez une organisation pour commencer</p>
        </div>
      )}
    </div>
  );
};

export default ActivitesPage;